import type { IDropdownOption } from '@fluentui/react';
import { Stack } from '@fluentui/react';
import { Dropdown, Item, itemStylesTag } from '@h2oai/ui-kit';
import { useMemo } from 'react';

import type { Tag } from '../../../authz/gen/ai/h2o/workspace/v1/tag_pb';

interface ManageTagsProps {
  selectedTags: string[];
  availableTags: Tag[] | undefined;
  tagsMap?: Map<string, Tag>;
  showTagChips?: boolean;
  onChange: (_e: unknown, option?: IDropdownOption) => void;
  disabled?: boolean;
}

export const ManageTags = (props: ManageTagsProps) => {
  const { selectedTags, availableTags, tagsMap, showTagChips = true, onChange, disabled } = props;

  const tagOptions = useMemo((): IDropdownOption[] => {
    if (!availableTags) return [];
    return availableTags.map(({ name, displayName }, index) => ({
      key: name || String(index),
      text: displayName || String(index),
    }));
  }, [availableTags]);

  return (
    <>
      {showTagChips && selectedTags.length > 0 && tagsMap && (
        <Stack horizontal tokens={{ childrenGap: 8 }} styles={{ root: { paddingLeft: 48, paddingBottom: 8 } }}>
          {selectedTags.map((tagName) => {
            const tagData = tagsMap.get(tagName);
            if (!tagData) return null;

            return (
              <Item
                key={tagName}
                styles={itemStylesTag}
                labelField="displayName"
                titleField="description"
                hasTooltip
                emptyTooltip="No description available."
                data={tagData}
              />
            );
          })}
        </Stack>
      )}
      <Dropdown
        multiSelect
        selectedKeys={selectedTags}
        onChange={onChange}
        placeholder="Select tags"
        options={tagOptions}
        disabled={disabled}
      />
    </>
  );
};
